import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import InventoryItemForm from '../../components/InventoryItemForm'
import OverrideInventoryItemViewModel from './OverrideInventoryItemViewModel'
import InventoryItemFormWorkspaceDropdown from '../../components/InventoryItemFormWorkpaceDropdown'

interface Props {
  vm: OverrideInventoryItemViewModel
}

function OverrideInventoryItemDialog({ vm }: Props) {
  const description = vm.workspace ? (
    <Fragment>
      Override service items to better manage pricing calculations for the{' '}
      <strong>{vm.workspace.name}</strong> workspace.
    </Fragment>
  ) : (
    `Override the selected service item to better manage pricing
      calculations for another workspace`
  )

  const showSelect = !vm.getSelectedWorkspace()

  return (
    <InventoryItemForm
      title="Override service item"
      submitText="Override"
      overridden={true}
      vm={vm}
      description={description}
    >
      {showSelect && (
        <InventoryItemFormWorkspaceDropdown
          vm={vm}
          workspaceSelectorVM={vm.workspaceSelectorVM}
        />
      )}
    </InventoryItemForm>
  )
}

export default observer(OverrideInventoryItemDialog)
